import { useEffect, useState } from 'react';
import ErrorScreen from '~/components/ErrorScreen/ErrorScreen';
import { DASHBOARD_DIV_ID, serviceErrorCodes } from '~/constants';
import {
  openServicingDashboard,
  resumeApplication,
} from '~/services/SdkService';
import type { SdkError } from '~/types/interaction';
import { getErrorMessage } from '~/utils/utilities';

const Service = () => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  //launch the servicing dashboard in guest mode
  const openDashboard = async () => {
    const [ok, result] = await openServicingDashboard({
      target: DASHBOARD_DIV_ID,
      onTopupTriggered: async (userId) => {
        const [ok, result] = await resumeApplication('TOP_UP', userId);
        if (!ok) {
          setError(getErrorMessage(result as SdkError));
        }
      },
    });
    if (!ok) {
      if ((result as SdkError)?.code !== serviceErrorCodes.TOPUP_TRIGGERED) {
        setError(getErrorMessage(result as SdkError));
        return;
      }
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    openDashboard();
  }, []);

  return !loading && error ? (
    <ErrorScreen
      message="Resume application to start where you left off and get instant loan"
      title="Complete your application"
      ctaText="Resume application"
      onButtonClick={async () => {
        setError(null);
        setLoading(true);
        await openDashboard();
        setLoading(false);
      }}
    />
  ) : (
    <div id={DASHBOARD_DIV_ID} className="border" />
  );
};

export default Service;
